import { useSelector } from "react-redux";
import { BASE_URL } from "../../services/api";

import api from "../../services/instanceapi";

const useAssistant = () => {
  const { activity } = useSelector((state) => state.strategy);
  const {projects} = useSelector((state) => state.projects);
  const projectsList = projects.map(p => p.name)

  const requestSuggestion = (context, comment) => {
    const prompt = [];

    const commentContext =
        context.comment && context.comment.length > 0
            ? ` qui a pour but: ${context.comment}`
            : "";

    const weaknessContext =
        context.weakness && context.weakness.length > 0
            ? ` qui répondent à une des faiblesse suivantes:  - ${context.weakness.join(
                " -"
            )}`
            : "";

    const threatContext =
        context.threat && context.threat.length > 0
            ? ` qui répondent à une des problématiques suivantes:  - ${context.threat.join(
                " -"
            )}`
            : "";

    const strengthContext =
        context.strength && context.strength.length > 0
            ? ` qui prend en compte les forces suivantes :  - ${context.strength.join(
                " -"
            )}`
            : "";

    const opportunityContext =
        context.opportunity && context.opportunity.length > 0
            ? ` qui prend en compte les opportunités suivantes :  - ${context.opportunity.join(
                " -"
            )}`
            : "";

    if (context.object === "axis_analysis") {
      prompt.push({
        role: "user",
        content: `Voici le contexte : mon entreprise a un plan stratégique. Mon entreprise a cette activité : 
        ${activity}. Dans le cadre de cette stratégie, j'ai notamment un axe : ${
            context.axis
        } qui a comme précision : 
        ${
            context.axisDescription
        }. J'ai le SWOT suivant pour cet axe stratégique : Faiblesses : 
        ${context.weakness.join(", ")}. Menaces : ${context.threats.join(", ")}. Forces : ${context.strength.join(", ")}. Opportunités : ${context.opportunity.join(", "
        )}. Je souhaite que tu me dises si la liste suivante des projets peut suffire à répondre aux faiblesses et menaces : 
        Liste des projets : ${context.projects.join(
            ", "
        )}. Dans une première partie, indique quels projets actuels sont pertinents et pourquoi ils le sont. Dans une seconde partie, donne des idées de nouveaux projets pour réduire ou supprimer les faiblesses et menaces dont tu as eu la liste précédemment. 
        Dans une troisième partie, donne des idées de nouveaux projets pour renforcer les forces actuelles et capter les opportunités dont tu as eu la liste précédemment.
        Les projets que tu proposes doivent être différents de ceux dont tu as eu la liste. Ils ne doivent pas faire doublon.
        Tu donneras maximum 5 projets pour la seconde partie et la troisième partie.
        . Enfin fais une conclusion en indiquant ce que tu en penses. 
        Pour rédiger tout cela, endosse le rôle d'un consultant expert en stratégie d'entreprise qui s'adresse sur un ton professionnel au dirigeant de l'entreprise. Ne mets pas de signature.
        Pour l'ensemble de cette rédaction, commence directement par "Après une analyse approfondie de votre axe stratégique, voici une évaluation de vos projets actuels." 
        Egalement, ne rédige pas en employant le "Je".
        `,
      });
    }
    else if (context.object === "project_analysis") {
      prompt.push({
        role:"user",
        content: `
          Voici le contexte : mon entreprise a un plan stratégique. Mon entreprise a cette activité : ${activity}. Dans le cadre de cette stratégie, j'ai notamment un axe : ${context.axis}
           qui a comme précision : ${context.axisDescription}. Dans cet axe, j'ai un projet ${context.project} qui a comme précision ${context.projectDescription}. 
           J'ai le SWOT suivant pour ce projet : Faiblesses : ${context.weakness.join(", ")} . Menaces : ${context.threats.join(", ")} . Forces : ${context.strength.join(", ")}. 
           Opportunités : ${context.opportunity.join(", ")}. ${context.objectives.length > 0 ? `Je souhaite que tu me dises si la liste suivante des objectifs à atteindre : ${context.objectives.join(", ")}` : "" }
           ${context.actions.length > 0 ? `et la liste suivante des actions :${context.actions.join(", ")}` : ""}} sont pertinents pour répondre aux faiblesses et menaces, 
           et également pour capter les opportunités cités précédemment. Dans une première partie, indique quels objectifs et actions donnés sont pertinents et pourquoi ils le sont. 
           Dans une seconde partie, donne 2 idées de nouveaux objectifs pour réduire ou supprimer les faiblesses et menaces ou bien capter les opportunités dont tu as eu la liste précédemment. 
           Dans une troisième partie, donne 3 actions nouvelles pour diminuer ou supprimer les faiblesses et les menaces ainsi que renforcer les forces actuelles, 
           capter les opportunités dont tu as eu la liste précédemment. Les objectifs et actions que tu proposes doivent être différents de ceux dont tu as eu déjà la liste. 
           Ils ne doivent pas faire doublon. Enfin fais une conclusion en indiquant ce que tu en penses. Pour rédiger tout cela, endosse le rôle d'un consultant expert en stratégie d'entreprise 
           qui s'adresse sur un ton professionnel au dirigeant de l'entreprise. Ne mets pas de signature. Pour l'ensemble de cette rédaction, commence directement par 
           "Après une analyse approfondie du projet -nom du projet-, voici son évaluation" Egalement, ne rédige pas en employant le "Je".
        `,
      });
    }
    else if (context.object === "axis") {
      prompt.push({
        role: "user",
        content:
            `Donne moi 5 axes stratégiques pour une organisation de type ${activity}. ` +
            `N'ajoute aucun texte en dehors des 5 propositions et rends moi la réponse sous le format JSON {"name":string,"description":string}[]`,
      });
    } else if (context.object === "stake") {
      prompt.push({
        role: "user",
        content:
            `Donne moi 5 enjeux qui commencent par un verbe pour l'axe ${context.axis} ${weaknessContext} ${threatContext} pour une organisation de type ${activity}.` +
            `N'ajoute aucun texte en dehors des 5 propositions et rends moi la réponse sous le format JSON {"name":string,"description":string}[]`,
      });
    } else if (context.object === "project") {
      prompt.push({
        role: "user",
        content:
            `Donne moi 6 exemples de projets en tout (Ne les numérote pas) qui répondent à l'enjeu "${context.stake}" ${context.weakness.length > 0 ? "et qui répondent à une des faiblesses suivantes: " + context.weakness + "(donne 2 projets)," : ""}
          ${context.threat.length > 0 ? "qui répondent à une des problématiques suivantes :" + context.threat + "(donne 2 projets)," : ""} ${context.strength.length > 0 ? "qui répondent à une des problématiques suivantes :" + context.strength + "(donne 1 projet)," : ""}
          ${context.opportunity.length > 0 ? "qui répondent à une des problématiques suivantes :" + context.opportunity + "(donne 1 projet)," : ""} pour une organisation de type "${activity}". Les propositions ne doivent pas être identiques un l'un des éléments de cette liste : "${projectsList.join(", ")}".` +
            `N'ajoute aucun texte en dehors des 6 propositions et rends moi la réponse sous le format JSON {"name":string,"description":string}[]`,
      });
    }
    else if (context.object === "improveAxis") {
      prompt.push({
        role: "user",
        content:
            `Dans l'entreprise qui a comme activité " ${activity} ", j'ai un axe stratégique " ${context.axis} ". En quoi l'intelligence artificielle peut m'aider dans cet axe stratégique : 
            donne moi 5 exemples concrets des plus pertinents. Et je souhaite pour chaque exemple concret une explication fine du comment le faire.` +
            'N\'ajoute aucun texte en dehors des 5 propositions et rends moi la réponse sous le format JSON {"name":string,"description":string}[]',
      });
    }
    else if (context.object === "improveProject") {
      prompt.push({
        role: "user",
        content:
            `Dans l'entreprise qui a comme activité " ${activity} ", j'ai un projet stratégique " ${context.project} " 
            ${context.projectDescription.length > 0 ? `prend en compte son commentaire : " ${context.projectDescription} "` : ""}. 
            En quoi l'intelligence artificielle peut m'aider dans ce projet : donne moi 5 exemples concrets des plus pertinents. 
            Et je souhaite pour chaque exemple concret une explication fine du comment le faire.` +
            'N\'ajoute aucun texte en dehors des 5 propositions et rends moi la réponse sous le format JSON {"name":string,"description":string}[]',
      });
    }
    else if (context.object === "idea") {
      prompt.push({
        role: "user",
        content:
            `Donne moi 5 exemples d'idées qui commencent par un verbe à développer dans le cadre d'un projet ${context.project} ${commentContext} ${weaknessContext} ${threatContext} pour une organisation de type ${activity}.` +
            `N'ajoute aucun texte en dehors des 5 propositions et rends moi la réponse sous le format JSON {"name":string,"description":string}[]`,
      });
    } else if (context.object === "objective") {
      prompt.push({
        role: "user",
        content:
            `Donne moi 5 exemples d'objectifs à se fixer dans le cadre d'un projet ${context.project} ${commentContext} pour une organisation de type ${activity}.` +
            `N'ajoute aucun texte en dehors des 5 propositions et rends moi la réponse sous le format JSON {"name":string,"description":string}[]`,
      });
    } else if (context.object === "indicator") {
      prompt.push({
        role: "user",
        content:
            `Donne moi 5 exemples d'indicateurs en pourcentage ou en quantité sur une période défini à suivre pour répondre à l'objectif ${context.goal} dans le cadre d'un projet ${context.project} ${commentContext} pour une organisation de type ${activity}.` +
            `N'ajoute aucun texte en dehors des 5 propositions et rends moi la réponse sous le format JSON {"name":string,"description":string}[]`,
      });
    } else if (context.object === "action") {
      prompt.push({
        role: "user",
        content:
            `Donne moi 5 exemples d'actions à mettre en place dans le cadre d'un projet ${context.project} ${commentContext} pour une organisation de type ${activity}.` +
            `N'ajoute aucun texte en dehors des 5 propositions et rends moi la réponse sous le format JSON {"name":string,"description":string}[]`,
      });
    } else if (context.object === "swot" && context.entity === "axis") {
      prompt.push({
        role: "user",
        content:
            `Donne moi 5 exemples de 200 caractères maximum chacun de ${context.type}s dans un SWOT pour l'axe "${context.entityName}" ${commentContext}, pour une organisation de type ${activity}.` +
            'N\'ajoute aucun texte en dehors des 5 propositions et rends moi la réponse sous le format JSON {"name":string,"description":string}[]',
      });
    } else if (context.object === "swot" && context.entity === "project") {
      prompt.push({
        role: "user",
        content:
            `Rôle à jouer: Analyste SWOT expérimenté,
     Donne moi 5 exemples de 200 caractères maximum chacun de "${context.type}" (Ne les numérote pas) dans un SWOT pour le projet "${context.entityName}" ${commentContext}  
     pour une organisation de type ${activity}.
     En consigne complémentaire : respecte bien que les forces et faiblesses sont des items relèvent de l'interne à l'organisation alors que menaces et opportunités relèvent 
     de l'externe à l'organisation.` +
            'N\'ajoute aucun texte en dehors des 5 propositions et rends moi la réponse sous le format JSON {"name":string,"description":string}[]',
      });
    } else if (context.object === "success") {
      prompt.push({
        role: "user",
        content: `Quelles seraient en 50 mots les 5 valeurs d'une entreprise comme: ${activity}.`,
      });
    } else if (context.object === "vision") {
      prompt.push({
        role: "user",
        content: `Quelles seraient en 50 mots 3 exemples de visions d'une entreprise comme: ${activity}.`,
      });
    } else if (context.object === "goal") {
      prompt.push({
        role: "user",
        content: `Quelles seraient en 50 mots 3 exemples de missions d'une entreprise comme: ${activity}.`,
      });
    } else if (context.object === "duty") {
      prompt.push({
        role: "user",
        content: `Quels seraient en 50 mots les 3 exemples d'ambitions (avec positionnement sur son marché) d'une entreprise comme: ${activity}.`,
      });
    }
    prompt[0].content += ", et n'utilise pas le markdown."
    if(comment?.length > 0){
      prompt[0].content += (" " + comment)
    }

    return api
        .post(`${BASE_URL}ai`, {
          model: "gpt-3.5-turbo",
          messages: prompt,
          max_tokens: 1000,
          temperature: 0,
        })
        .then((response) => response.data);
  };

  return {
    requestSuggestion,
  };
};

export default useAssistant;
